import Tooltip from '@mui/material/Tooltip';
import { Button, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useIntl } from "react-intl";
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

const ShootPhoto = (props) => {
  const intl = useIntl();

  const [photo, setPhoto] = useState(null);
  const [photoTaken, setPhotoTaken] = useState(false);
  
  function handleTakePhoto (dataUri) {
    setPhoto(dataUri);
  }

  useEffect(() => {
    setPhotoTaken(photo !== null)
  }, [photo])

  const handleUsePhoto = () => {
    props.photoTakenAction(photo);
  }

  const handleCancel = (e) => {
    e.preventDefault();
    props.exitShootPhoto();
  }

  return (
    <Box mt={5} id="takePhoto" textAlign={'center'}>
      <Grid container ml={'auto'} mr={'auto'} sx={{backgroundColor:'#9C9B9B', width: '68vw'}}>
        <Grid item xs={1} textAlign={'left'}>
          <Button variant="text" sx={{color:'white'}} onClick={(e) => {handleCancel(e)}}>{intl.formatMessage({ id: "General.Cancel" })}</Button>
        </Grid>
      </Grid>
      <div style={{marginTop: '5px'}}>
      { 
        !photoTaken ?
        <div>
          <Camera isMaxResolution={true} onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); }} />            
        </div>
        :
        <div>
          <img style={{width:'68vw'}} src={`${photo}`} alt="sketch" />
          <Grid container ml={'auto'} mr={'auto'} sx={{backgroundColor:'#9C9B9B', width: '68vw'}}>
            <Grid item xs={1} textAlign={'left'}>
              <Button variant="text" sx={{color:'white'}} onClick={(e) => {e.preventDefault(); setPhoto(null)}}>{intl.formatMessage({ id: "Image.Retake" })}</Button>
            </Grid>
            <Grid item xs={9}>
            </Grid>
            <Grid item xs={2} textAlign={'right'}>
            <Button variant="text" sx={{color:'white'}} onClick={handleUsePhoto}>{intl.formatMessage({ id: "Image.UsePhoto" })}</Button>
            </Grid>
          </Grid>
        </div>
      }
      </div>
    </Box>
  );
};

export default ShootPhoto;